import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.titles = [...this.$( 'title' ) ];
        this.onResizeBind = this.onResize.bind( this );
        window.addEventListener( 'resize', this.onResizeBind );
        this.onResize();
    }

    onResize(){
        this.el.classList.add( 'auto' );

        setTimeout( ()=>{
            let maxH = 0;
            this.titles.forEach( t => maxH = Math.max( maxH, t.offsetHeight) );
            this.el.classList.remove( 'auto' );
            this.titles.forEach( t => t.style.height = maxH + 'px' );
        }, 10);

    }

    destroy(){
        window.removeEventListener( 'resize', this.onResizeBind );
    }

}
